<template>
  <footer class="footer">
    <div class="container">
      <div class="row align-items-center flex-row-reverse">
        <div class="col-md-12 col-sm-12 mt-3 mt-lg-0 text-center">
          Copyright © {{year}}
          <a href="/">{{title}}</a>.
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
import config from '../../../.pagenify/config'
export default {
  data() {
    return {
      year: new Date().getFullYear(),
      title: config.website.title,
    }
  },
}
</script>
